import { useCallback } from 'react';

import { useRepository } from '@/Application/Providers/Repository/Repository';
import { useCart } from '@/Application/Selectors/cart/useCart';
import { updateShippingOption } from '@/modules/cart/application/updateShippingOption';
import type { Cart } from '@/modules/cart/domain/Cart';
import type { TimeSlotValue } from '@/modules/shippingMethod/domain/ShippingMethod';
import type { DeliveryGroupDto } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';
import useGetGeneralShippingMethods from '@/sections/shippingMethods/hooks/useGetGeneralShippingMethods';
import { findCartDeliveryGroup } from '@/sections/shippingMethods/mappers/shippingMethodMapper';

const useSetTimeFrame = () => {
  const { cart: cartRepository } = useRepository();
  const { data: cart } = useCart();
  const { results } = useGetGeneralShippingMethods();

  const searchCartDeliveryId = useCallback(
    (deliveryGroupId: string) => {
      const deliveryGroup = results?.deliveryGroups.find(
        (group) => group.id === deliveryGroupId
      );
      return findCartDeliveryGroup(
        cart as Cart,
        deliveryGroup as DeliveryGroupDto
      );
    },
    [cart, results]
  );

  const handleUpdateShippingOption = useCallback(
    (timeFrame: TimeSlotValue, deliveryGroupId: string) => {
      const cartDeliveryGroup = searchCartDeliveryId(deliveryGroupId);

      timeFrame.id = cartDeliveryGroup?.id as string;
      updateShippingOption(
        cartRepository,
        cartDeliveryGroup?.id as string,
        timeFrame
      );
    },
    [cartRepository, searchCartDeliveryId]
  );

  return {
    setShippingOption: handleUpdateShippingOption
  };
};

export default useSetTimeFrame;
